import { useSyncExternalStore } from 'react';
import { getMSTilMidnight, startOfDay } from '~/util/date';

let today = startOfDay(new Date());
const listeners = new Set<() => void>();

function refresh() {
	const next = startOfDay(new Date());
	if (next.getTime() !== today.getTime()) {
		today = next;
		listeners.forEach(x => x());
	}
	setTimeout(refresh, getMSTilMidnight() + 1000);
}

setTimeout(refresh, getMSTilMidnight() + 1000);
document.addEventListener('visibilitychange', () => {
	if (document.visibilityState === 'visible') {
		refresh();
	}
});

function subscribe(listener: () => void) {
	listeners.add(listener);
	return () => {
		listeners.delete(listener);
	};
}

function getSnapshot() {
	return today;
}

export function useToday() {
	return useSyncExternalStore(subscribe, getSnapshot);
}
